import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate} from 'react-router-dom';
import { getEmployees } from '../../redux/actions/employee.action';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import axios from 'axios';
import { setLoading } from '../../redux/actions/loader.action';
import { logout } from '../../redux/actions/auth.action';
import Paginate from '../../components/Paginate';

export default function EmployeesPage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const employees = useSelector(state => state.employees);
  const { me } = useSelector(state => state.auth);

  const modalRef = useRef(null);
  const fileRef = useRef(null);
  const detailsModalRef = useRef(null);
  const [employee, setEmployee] = useState(null);
  const [modal, setModal] = useState(null);

  const [actionModal, setActionModal] = useState(null);

  const [photo, setPhoto] = useState("");
  const [code, setCode] = useState("");
  const [recruitmentDate, setRecruitmentDate] = useState("");
  const [gender, setGender] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [cinNumber, setCinNumber] = useState("");
  const [cinDate, setCinDate] = useState("");
  const [cinCity, setCinCity] = useState("");
  const [address, setAddress] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [isMarried, setIsMarried] = useState(0);
  const [nbChildren, setNbChildren] = useState("");
  const [status, setStatus] = useState(0);

  const [isCodeTouched, setIsCodeTouched] = useState(false);
  const [isGenderTouched, setIsGenderTouched] = useState(false);
  const [isFirstnameTouched, setIsFirstnameTouched] = useState(false);
  const [isLastnameTouched, setIsLastnameTouched] = useState(false);
  const [isCinNumberTouched, setIsCinNumberTouched] = useState(false);
  const [isCinCityTouched, setIsCinCityTouched] = useState(false);
  const [isAddressTouched, setIsAddressTouched] = useState(false);
  const [isZipcodeTouched, setIsZipcodeTouched] = useState(false);
  const [isCityTouched, setIsCityTouched] = useState(false);
  const [isPhoneTouched, setIsPhoneTouched] = useState(false);

  const [errors, setErrors] = useState(null);

  useEffect(() => {
    dispatch(getEmployees(location, navigate));
  }, [location, dispatch, navigate]);

  const _close = useCallback(() => {
    setModal(null);
    setPhoto("");
    setCode("");
    setRecruitmentDate("");
    setGender("");
    setFirstname("");
    setLastname("");
    setBirthDate("");
    setCinNumber("");
    setCinDate("");
    setCinCity("");
    setAddress("");
    setZipcode("");
    setCity("");
    setPhone("");
    setIsMarried(0);
    setNbChildren("");
    setStatus(0);

    setIsCodeTouched(false);
    setIsGenderTouched(false);
    setIsFirstnameTouched(false)
    setIsLastnameTouched(false);
    setIsCinNumberTouched(false);
    setIsCinCityTouched(false);
    setIsAddressTouched(false);
    setIsZipcodeTouched(false);
    setIsCityTouched(false);
    setIsPhoneTouched(false);

    if(fileRef.current)
      fileRef.current.value = null;

    dispatch(setLoading(false));

    setErrors(null);

    setTimeout(() => {
      setEmployee(null);
    }, 200);
  }, [dispatch]);

  const close = useCallback((e) => {
    if(modalRef.current === e.target || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close')){
      _close();
    }
  }, [_close]);

  useEffect(() => {
    document.addEventListener('click', close);
    return () => {
      document.removeEventListener('click', close);
    }
  }, [close]);

  const updateEmployee = (id) => {
    setEmployee(employees && employees.data && employees.data.data.find(e => e.id === id) ? employees.data.data.find(e => e.id === id) : null);
  }

  useEffect(() => {
    if(employee){
      setCode(employee.code ? employee.code : "");
      setRecruitmentDate(employee.recruitment_date ? employee.recruitment_date : "");
      setGender(employee.gender ? employee.gender : "");
      setFirstname(employee.first_name ? employee.first_name : "");
      setLastname(employee.last_name ? employee.last_name : "");
      setBirthDate(employee.birth_date ? employee.birth_date : "");
      setCinNumber(employee.cin_number ? employee.cin_number : "");
      setCinDate(employee.cin_date ? employee.cin_date : "");
      setCinCity(employee.cin_city ? employee.cin_city : "");
      setAddress(employee.address ? employee.address : "");
      setZipcode(employee.zipcode ? employee.zipcode : "");
      setCity(employee.city ? employee.city : "");
      setPhone(employee.phone ? employee.phone : "");
      setIsMarried(employee.is_married ? 1 : 0);
      setNbChildren(employee.nb_children ? employee.nb_children : "");
      setStatus(employee.status ? 1 : 0);
    }
  }, [employee]);

  useEffect(() => {
    if(modal){
      const $modals = document.querySelectorAll('._modal-content');
      $modals.forEach($modal => {
        $modal.scrollTop = 0;
      });
    }
  }, [modal]);

  const handlePhotoChange = (e) => {
    const selectedPhoto = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
        const base64String = reader.result;
        setPhoto(base64String);
    };

    if (selectedPhoto) {
        reader.readAsDataURL(selectedPhoto);
    }
  }

  const handleSubmit = async(e) => {
    e.preventDefault();
    dispatch(setLoading(true));
    setErrors(null);
    const data = new FormData(e.target);

    if("add" === modal){
      await axios.post(`${ endpointApi }employees`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${ jwt_access}`
        }
      }).then(({ data }) => {
        dispatch(getEmployees(location, dispatch, navigate));
        setEmployee(data);
        setPhoto("");
        if(fileRef.current)
            fileRef.current.value = null;
        setModal("details");
      }).catch(err => {
        if(err.response.status === 401){
          dispatch(logout(location.pathname + location.search, navigate));
        }else{
          setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
          const $modals = document.querySelectorAll('._modal-content');
          $modals.forEach($modal => {
              $modal.scrollTop = 0;
          })
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
    }else{
      await axios.post(`${ endpointApi }employees/${ employee.id }`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${ jwt_access}`
        }
      }).then(({ data }) => {
        dispatch(getEmployees(location, dispatch, navigate));
        setEmployee(data);
        setPhoto("");
        if(fileRef.current)
            fileRef.current.value = null;
        setModal("details");
      }).catch(err => {
        if(err.response.status === 401){
          dispatch(logout(location.pathname + location.search, navigate));
        }else{
          setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
          const $modals = document.querySelectorAll('._modal-content');
          $modals.forEach($modal => {
            $modal.scrollTop = 0;
          });
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
    }
  }

  useEffect(() => {
    const clickOutsideActionModal = (e) => {
      const $actionModals = document.querySelectorAll('.actions>ul');
      $actionModals.forEach($actionModal => {
        if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
          setActionModal(null);
        }
      });
    }
    document.addEventListener('click', clickOutsideActionModal);
    return () => {
      document.removeEventListener('click', clickOutsideActionModal);
    }
  }, []);

  useEffect(() => {
    if(!jwt_access){
      navigate('/login?redirect_to=' + location.pathname + location.search);
    }
  }, [location, navigate, jwt_access]);

  return (
    me &&
    <HelmetProvider>
      <Helmet>
        <title>Employés - Société Mikalo</title>
      </Helmet>

      <Header />

      <Nav />

      <main id="main">
        <div className='title d-flex justify-content-between'>
          <h1>Employés</h1>
          <button type='button' onClick={ () => {
            setModal('add');
          } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
        </div>

        <div ref={ modalRef } className={ `_modal${ (modal === 'add' || (modal === 'update' && employee)) ? ' active' : '' }` }>
          <div className='_modal-content'>
              <div className='_modal-head'>
                <h4>{ modal === "add" ? 'Ajouter' : 'Modifier' } un employé</h4>
                <button className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                <form className='form' onSubmit={ handleSubmit }>
                  { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                  
                  <div className='pb-3'>
                      <label htmlFor='photo'>Photo</label><br/>
                      <input ref={ fileRef } type='file' name="photo" id="photo" accept='.png,.jpeg,.jpg' onChange={ handlePhotoChange } />
                      { (photo.length > 0 || (employee && employee.photo)) && <div className='pt-2'>
                        <div className='avatar'>
                          <img src={ photo.length ? photo : endpoint + 'storage/' + employee.photo } alt="" />
                        </div>
                      </div> }
                      { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                  </div>

                  { modal === "update" &&
                  <div className='mb-3'>
                    <label htmlFor='code' className='required'>Code</label>
                    <input type='text' id='code' name='code' placeholder='Code' autoComplete='off' className='form-control' required value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code employé.</div> }
                    { isCodeTouched && code.length > 0 && /^EMP\/\d{4}\/[0-9]{4,}$/.test(code) === false && <div className='form-error'>Ce code n'est pas valide. Le format valide est: EMP/[année]/[numéro d'ordre].</div> }
                    { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                  </div> }

                  <div className='pb-3'>
                    <label htmlFor='recruitment_date'>Date de recrutement</label>
                    <input type='date' id='recruitment_date' name='recruitment_date' placeholder='Date de recrutement' autoComplete='off' className='form-control' value={ recruitmentDate } onChange={ (e) => setRecruitmentDate(e.target.value) } />
                    { errors && errors.recruitment_date && <div className='form-error'>{ errors.recruitment_date[0] }</div> }
                  </div>
                  
                  <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>Etat civil</h6>
                  <div className='row'>
                    <div className='col-6 pb-3'>
                      <label htmlFor='last_name' className='required'>Nom</label>
                      <input type='text' id='last_name' name='last_name' placeholder='Nom' autoComplete='off' className='form-control' required value={ lastname } onChange={ (e) => setLastname(e.target.value) } onBlur={ () => setIsLastnameTouched(true) } />
                      { isLastnameTouched && lastname.length === 0 && <div className='form-error'>Veuillez saisir le nom.</div> }
                      { isLastnameTouched && lastname.length > 0 && lastname.length < 2 && <div className='form-error'>Le nom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                      { errors && errors.last_name && <div className='form-error'>{ errors.last_name[0] }</div> }
                    </div>

                    <div className='col-6 pb-3'>
                      <label htmlFor='first_name' className='required'>Prénom(s)</label>
                      <input type='text' id='first_name' name='first_name' placeholder='Prénom(s)' autoComplete='off' className='form-control' required value={ firstname } onChange={ (e) => setFirstname(e.target.value) } onBlur={ () => setIsFirstnameTouched(true) } />
                      { isFirstnameTouched && firstname.length === 0 && <div className='form-error'>Veuillez saisir le prénom.</div> }
                      { isFirstnameTouched && firstname.length > 0 && firstname.length < 2 && <div className='form-error'>Le prénom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                      { errors && errors.first_name && <div className='form-error'>{ errors.first_name[0] }</div> }
                    </div>
                  </div>

                  <div className='pb-3'>
                    <label htmlFor='birth_date'>Date de naissaince</label>
                    <input type='date' id='birth_date' name='birth_date' placeholder='Date de naissaince' autoComplete='off' className='form-control' value={ birthDate } onChange={ (e) => setBirthDate(e.target.value) } />
                    { errors && errors.birth_date && <div className='form-error'>{ errors.birth_date[0] }</div> }
                  </div>

                  <div className='pb-3'>
                    <label htmlFor='gender' className='required'>Sexe</label>
                    <select id='gender' name='gender' className='form-control' required value={ gender } onChange={ (e) => setGender(e.target.value) } onBlur={ () => setIsGenderTouched(true) }>
                      <option value="">Sélectionner...</option>
                      <option value="m">Homme</option>
                      <option value="f">Femme</option>
                    </select>
                    { isGenderTouched && gender.length === 0 && <div className='form-error'>Veuillez sélectionner le sexe.</div> }
                    { errors && errors.gender && <div className='form-error'>{ errors.gender[0] }</div> }
                  </div>

                  <div className='row'>
                    <div className='col-6 pb-3'>
                      <label>Marié(e)</label>
                      <div className='d-flex' style={{ gap: '20px' }}>
                        <label>
                          <input type='radio' name='is_married' value={ 1 } checked={ isMarried === 1 } onChange={ (e) => setIsMarried(1) } />
                          <div></div> Oui
                        </label>
                        <label>
                          <input type='radio' name='is_married' value={ 0 } checked={ isMarried === 0 } onChange={ (e) => setIsMarried(0) } />
                          <div></div> Non
                        </label>
                      </div>
                      { errors && errors.is_married && <div className='form-error'>{ errors.is_married[0] }</div> }
                    </div>

                    <div className='col-6 pb-3'>
                      <label htmlFor='nb_children'>Nombre d'enfants</label>
                      <input type='number' min={ 0 } step={ 1 } id='nb_children' name='nb_children' placeholder="Nombre d'enfants" autoComplete='off' className='form-control' value={ nbChildren } onChange={ (e) => setNbChildren(e.target.value) } />
                      { errors && errors.nb_children && <div className='form-error'>{ errors.nb_children[0] }</div> }
                    </div>
                  </div>
                  
                  <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>CIN</h6>
                  <div className='pb-3'>
                    <label htmlFor='cin_number'>N° (laharana)</label>
                    <input type='text' id='cin_number' name='cin_number' maxLength={ 12 } placeholder='N° (laharana)' autoComplete='off' className='form-control' value={ cinNumber } onChange={ (e) => setCinNumber(e.target.value) } onBlur={ () => setIsCinNumberTouched(true) } />
                    { isCinNumberTouched && cinNumber.length > 0 && /^\d{12}$/.test(cinNumber) === false && <div className='form-error'>Ce numéro de CIN n'est pas valide.</div> }
                    { errors && errors.cin_number && <div className='form-error'>{ errors.cin_number[0] }</div> }
                  </div>
                  
                  <div className='pb-3'>
                    <label htmlFor='cin_date'>Du (tamin'ny)</label>
                    <input type='date' id='cin_date' name='cin_date' placeholder="Du (tamin'ny)" autoComplete='off' className='form-control' value={ cinDate } onChange={ (e) => setCinDate(e.target.value) } />
                    { errors && errors.cin_date && <div className='form-error'>{ errors.cin_date[0] }</div> }
                  </div>

                  <div className='pb-3'>
                    <label htmlFor='cin_city'>À (tao)</label>
                    <input type='string' id='cin_city' name='cin_city' placeholder='À (tao)' autoComplete='off' className='form-control' value={ cinCity } onChange={ (e) => setCinCity(e.target.value) } onBlur={ () => setIsCinCityTouched(true) } />
                    { isCinCityTouched && cinCity.length > 0 && cinCity.length < 2 && <div className='form-error'>Ce nom de la ville est trop court. Veuillez saisir au moins 2 caractères.</div> }
                    { errors && errors.cin_city && <div className='form-error'>{ errors.cin_city[0] }</div> }
                  </div>

                  <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>Adresse et Contact</h6>
                  <div className='pb-3'>
                    <label htmlFor='address'>Adresse</label>
                    <input type='text' id='address' name='address' placeholder='Adresse' autoComplete='off' className='form-control' value={ address } onChange={ (e) => setAddress(e.target.value) } onBlur={ () => setIsAddressTouched(true) } />
                    { isAddressTouched && address.length > 0 && address.length < 2 && <div className='form-error'>Cette adresse est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                    { errors && errors.address && <div className='form-error'>{ errors.address[0] }</div> }
                  </div>
                  <div className='row'>
                    <div className='col-6 pb-3'>
                      <label htmlFor='zipcode'>Code postal</label>
                      <input type='text' id='zipcode' name='zipcode' placeholder='Code postal' autoComplete='off' className='form-control' value={ zipcode } onChange={ (e) => setZipcode(e.target.value) } onBlur={ () => setIsZipcodeTouched(true) } />
                      { isZipcodeTouched && zipcode.length > 0 && /^\d{3,10}$/.test(zipcode) === false && <div className='form-error'>Ce code postal n'est pas valide.</div> }
                      { errors && errors.zipcode && <div className='form-error'>{ errors.zipcode[0] }</div> }
                    </div>
                    <div className='col-6 pb-3'>
                      <label htmlFor='city'>Ville</label>
                      <input type='text' id='city' name='city' placeholder='Ville' autoComplete='off' className='form-control' value={ city } onChange={ (e) => setCity(e.target.value) } onBlur={ () => setIsCityTouched(true) } />
                      { isCityTouched && city.length > 0 && city.length < 2 && <div className='form-error'>Le nom de la ville est trop court. Veuillez saisir au moins 2 caractères.</div> }
                      { errors && errors.city && <div className='form-error'>{ errors.city[0] }</div> }
                    </div>
                  </div>
                  <div className='pb-3'>
                    <label htmlFor='phone'>Téléphone</label>
                    <input type='text' id='phone' name='phone' placeholder='Téléphone' autoComplete='off' className='form-control' value={ phone } onChange={ (e) => setPhone(e.target.value) } onBlur={ () => setIsPhoneTouched(true) } />
                    { isPhoneTouched && phone.length > 0 && /^(\+261|0)\s?3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false && <div className='form-error'>Ce numéro de téléphone n'est pas valide.</div> }
                    { errors && errors.phone && <div className='form-error'>{ errors.phone[0] }</div> }
                  </div>

                  <div className='pb-3'>
                    <label>
                      <input type='checkbox' name='status' checked={ status === 1 } onChange={ (e) => setStatus(e.target.checked ? 1 : 0) } />
                      <div></div>
                      Actif
                    </label>
                  </div>

                  <div className='pt-2 text-end'>
                    <button type='submit' className='btn btn-lg btn-primary' disabled= {
                      gender.length === 0 || firstname.length < 2 || lastname.length < 2 || (phone.length > 0 && /^(\+261|0)\s?3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false) || (cinNumber.length > 0 && /^\d{12}$/.test(cinNumber) === false) || (cinCity.length > 0 && cinCity.length < 2) || (address.length > 0 && address.length < 2) || (zipcode.length > 0 && /^\d{3,10}$/.test(zipcode) === false) || (city.length > 0 && city.length < 2) ||
                      (photo === "" && employee && "add" !== modal && gender === employee.gender && firstname === employee.first_name && lastname === employee.last_name && phone === employee.phone && employee.recruitment_date === recruitmentDate && birthDate === employee.birth_date && nbChildren === employee.nb_children && cinNumber === employee.cin_number && cinCity === employee.cin_city && cinDate === employee.cin_date && address === employee.address && zipcode === employee.zipcode && city === employee.city && employee.is_married === isMarried)
                    }>{ "add" === modal ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                  </div>
                </form>
              </div>
          </div>
        </div>

        <div ref={ detailsModalRef } className={ `_modal${ (modal === 'details' && employee) ? ' active' : '' }` }>
          <div className='_modal-content'>
            <div className='_modal-head'>
              { employee && <>
                <h4>{ employee.last_name + " " + employee.first_name }</h4>
                <button className='_modal-close'>&times;</button>
              </> }
            </div>
            <div className='_modal-body'>
            { employee && <>
              <div className='mb-3'>
                <div className='_label'>Photo</div>
                <div className='_value'>
                  <div className='avatar'>
                    { employee.photo ?
                      <img src={ `${ endpoint }storage/${ employee.photo }` } alt='' /> :
                      employee.first_name.charAt(0)
                    }
                  </div>
                </div>
              </div>
              <div className='mb-3'>
                <div className='_label'>Code</div>
                <div className='_value'>{ employee.code }</div>
              </div>
              <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>Etat civil</h6>
              <div className='mb-3'>
                <div className='_label'>Date de recrutement</div>
                <div className='_value'>{ employee.recruitment_date ? dateFormat(employee.recruitment_date) : 'Non renseignée' }</div>
              </div>
              <div className='row'>
                <div className='col-6 mb-3'>
                  <div className='_label'>NOM</div>
                  <div className='_value'>{ employee.last_name }</div>
                </div>
                <div className='col-6 mb-3'>
                  <div className='_label'>Prénom(s)</div>
                  <div className='_value'>{ employee.first_name }</div>
                </div>
              </div>
              <div className='mb-3'>
                <div className='_label'>Date de naissaince</div>
                <div className='_value'>{ employee.birth_date ? dateFormat(employee.birth_date) : 'Non renseignée' }</div>
              </div>
              <div className='mb-3'>
                <div className='_label'>Sexe</div>
                <div className='_value'>{ employee.gender === 'm' ? 'Homme' : 'Fille' }</div>
              </div>
              <div className='row'>
                <div className='col-6 mb-3'>
                  <div className='_label'>Marié(e)</div>
                  <div className='_value'>{ employee.is_married !== null ? (employee.is_married ? <span className='badge bg-success'>Oui</span> : <span className='badge bg-dark'>Non</span>) : 'Non renseigné' }</div>
                </div>
                <div className='col-6 mb-3'>
                  <div className='_label'>Nombre d'enfant</div>
                  <div className='_value'>{ employee.nb_children ? employee.nb_children : 'Non renseigné' }</div>
                </div>
              </div>
              
              <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>CIN</h6>
              <div className='row'>
                <div className='col-4 mb-3'>
                  <div className='_label'>N° CIN</div>
                  <div className='_value'>{ employee.cin_number ? employee.cin_number : 'Non renseigné' }</div>
                </div>
                <div className='col-4 mb-3'>
                  <div className='_label'>DU</div>
                  <div className='_value'>{ employee.cin_date ? dateFormat(employee.cin_date) : 'Non renseigné' }</div>
                </div>
                <div className='col-4 mb-3'>
                  <div className='_label'>À</div>
                  <div className='_value'>{ employee.cin_city ? employee.cin_city : 'Non renseigné' }</div>
                </div>
              </div>

              <h6 style={{ fontSize: "15px", marginBottom: ".25rem" }}>Adresse et Contact</h6>
              <div className='mb-3'>
                <div className='_label'>Adresse</div>
                <div className='_value'>{ employee.address && employee.zipcode && employee.city ? employee.address + ", " + employee.zipcode + " " + employee.city : 'Non renseignée' }</div>
              </div>

              <div className='mb-3'>
                <div className='_label'>Téléphone</div>
                <div className='_value'>{ employee.phone ? employee.phone : 'Non renseigné' }</div>
              </div>

              <div className='text-end pt-2'>
                <button className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className='fa fa-edit'></i> Modifier</button>
              </div>
            </> }
            </div>
          </div>
        </div>

        <div className='box'>
          <table className='table table-striped'>
            <thead>
              <tr>
                <th width="100">Code</th>
                <th width="50px"></th>
                <th>Nom et prénom(s)</th>
                <th>Sexe</th>
                <th width="140">Date de recru.</th>
                <th>Téléphone</th>
                <th width="100">Statut</th>
                <th width="75" className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
            { employees.loading && <tr><td colSpan={ 8 }>Chargement...</td></tr> }
            { employees.loading === false && employees.data && employees.data.total === 0 && <tr><td colSpan={ 8 }>Aucun élément trouvé</td></tr> }
            { employees.loading === false && employees.data && employees.data.data && employees.data.data.map((item, index) => {
              return (
              <tr key={ index }>
                <td>{ item.code }</td>
                <td>
                  <div className='avatar avatar-32x32'>
                  {
                    item.photo ?
                    <img src={ `${ endpoint }storage/${ item.photo }` } alt='' /> :
                    item.first_name.charAt(0)
                  }
                  </div>
                </td>
                <td>{ item.last_name } { item.first_name }</td>
                <td>{ item.gender === 'm' ? 'Homme' : 'Fille' }</td>
                <td>{ item.recruitment_date ? dateFormat(item.recruitment_date) : '-' }</td>
                <td>{ item.phone ? item.phone : '-' }</td>
                <td>{ item.status ? <span className='badge bg-success'><i className='fa fa-check-circle'></i> Actif</span> : <span className='badge bg-danger'><i className='fa fa-times-circle'></i> Inactif</span> }</td>
                <td className='text-end'>
                  <div className='actions'>
                    <button type='button' className='toggle-action' onClick={ (e) => {
                      e.stopPropagation();
                      setActionModal(actionModal !== item.id ? item.id : null);
                    } }><i className='fa fa-ellipsis-v'></i></button>
                    <ul className={ actionModal === item.id ? 'active' : '' }>
                      <li><button onClick={ () => {
                        setModal("details");
                        setActionModal(null);
                        setEmployee(item);
                      } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                      <li><button type='button' onClick={ () => {
                        setActionModal(null);
                        updateEmployee(item.id);
                        setModal("update");
                      } }><i className='fa fa-edit'></i> Modifier</button></li>
                    </ul>
                  </div>
                </td>
              </tr> ) })}
            </tbody>
          </table>
        </div>
        
        { employees && employees.data &&
        <Paginate currentPage={ employees.data.current_page } totalPages={ employees.data.last_page } pathname={ location.pathname } search={ location.search } /> }
      </main>
    </HelmetProvider>
  )
}
